:host 
  display: block
  width: 15rem
  padding: 1.5rem
  margin: 0.5rem
  border-radius: 0.4rem

  afs-flex-wrapper
    height: fit-content
    div
      padding: 0.5rem 1rem